export default __webpack_public_path__ + "static/docs-toc-screenshot-2d86f7c3903956ccf358c57dc0a096dd.png";